<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { provide, toRef } from 'vue'
import { cn } from '@ds/lib/utils'
import { SIDEBAR_COLLAPSED } from './const'

type Props = {
  collapsed?: boolean
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  collapsed: false,
})

provide(SIDEBAR_COLLAPSED, toRef(props, 'collapsed'))
</script>

<template>
  <aside
    aria-label="Sidebar"
    :class="cn(
      'font-ds flex h-full shrink-0 flex-col',
      'bg-sidebar border-r border-transparent dark:border-border text-primary-foreground',
      'transition-[width] duration-ds-normal ease-ds-standard',
      collapsed ? 'w-15.5' : 'w-58.5',
      props.class,
    )"
  >
    <div class="flex h-14.5 shrink-0 items-center px-3">
      <slot name="logo" />
    </div>
    <div
      v-if="$slots.top"
      class="px-3 pb-3.5 mb-2"
    >
      <slot name="top" />
    </div>
    <nav
      aria-label="Primary"
      class="flex min-h-0 flex-1 flex-col gap-0.5 overflow-y-auto px-3 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-white/20"
    >
      <slot />
    </nav>
    <div
      v-if="$slots.footer"
      class="flex shrink-0 flex-col gap-0.5 border-t border-white/15 p-3"
    >
      <slot name="footer" />
    </div>
  </aside>
</template>
